import { render, staticRenderFns } from "./RmaClarifications.vue?vue&type=template&id=19622a49&scoped=true"
import script from "./RmaClarifications.vue?vue&type=script&lang=js"
export * from "./RmaClarifications.vue?vue&type=script&lang=js"
import style0 from "./RmaClarifications.vue?vue&type=style&index=0&id=19622a49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19622a49",
  null
  
)

export default component.exports